// @flow

export default function pinGridInnerCSS() {
  return `
.PinGrid__placeholder {
  display: inline-block;
  padding-bottom: 36px;
  visibility: hidden;
}

.PinGridInner__brioPin {
  background: white;
  border-radius: 6px;
  display: inline-block;
  font-size: 11px;
  position: relative;
  pointer-events: auto;
}
.PinGridInner__brioPin.relatedPin {
  background-color: transparent;
}
`;
}
